import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var style = require('./ParallaxTemplate.css');
var BACKGROUND_MAX_HEIGHT = 740;
export var ParallaxTemplate = /*#__PURE__*/function (_React$Component) {
  _inherits(ParallaxTemplate, _React$Component);
  var _super = _createSuper(ParallaxTemplate);
  function ParallaxTemplate(props) {
    var _this;
    _classCallCheck(this, ParallaxTemplate);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "container", null);
    _defineProperty(_assertThisInitialized(_this), "animatedBg", null);
    _defineProperty(_assertThisInitialized(_this), "topPosition", void 0);
    _defineProperty(_assertThisInitialized(_this), "bottomPosition", void 0);
    _defineProperty(_assertThisInitialized(_this), "containerHeight", void 0);
    _defineProperty(_assertThisInitialized(_this), "scrollHandler", void 0);
    _defineProperty(_assertThisInitialized(_this), "resizeHandler", void 0);
    _this.state = {
      bgPosition: 0
    };
    return _this;
  }
  _createClass(ParallaxTemplate, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (this.container) {
        var shouldChange = false;
        this.containerHeight = this.container.offsetHeight;
        var scrollHandler = function scrollHandler() {
          if (!shouldChange) {
            return;
          }
          shouldChange = false;
          if (window.scrollY > _this2.topPosition && window.scrollY < _this2.bottomPosition && _this2.animatedBg) {
            var bgOffset = (window.scrollY - _this2.topPosition) / (window.innerHeight + BACKGROUND_MAX_HEIGHT);
            var translate = bgOffset * (_this2.containerHeight - BACKGROUND_MAX_HEIGHT);
            _this2.animatedBg.style.transform = "translateY(".concat(Math.round(translate), "px)");
          }
        };
        var img = new Image();
        this.scrollHandler = function () {
          shouldChange = true;
          requestAnimationFrame(scrollHandler);
        };
        this.resizeHandler = function () {
          _this2.getParams();
          requestAnimationFrame(scrollHandler);
        };
        img.onload = function () {
          _this2.getParams();
          _this2.setState({
            bgPosition: window.innerHeight - BACKGROUND_MAX_HEIGHT
          });
          window.addEventListener('scroll', _this2.scrollHandler);
          window.addEventListener('resize', _this2.resizeHandler);
        };
        img.src = this.props.backgroundImage;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.scrollHandler);
      window.removeEventListener('resize', this.resizeHandler);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        backgroundImage = _this$props.backgroundImage,
        textImage = _this$props.textImage,
        footnote = _this$props.footnote,
        url = _this$props.url;
      return /*#__PURE__*/_jsx("a", {
        "data-name": "ParallaxTemplate",
        href: url,
        target: "_blank",
        rel: "noreferrer noopener nofollow",
        children: /*#__PURE__*/_jsxs("div", {
          className: style['container'],
          ref: function ref(container) {
            _this3.container = container;
          },
          children: [/*#__PURE__*/_jsx("div", {
            ref: function ref(animatedBg) {
              return _this3.animatedBg = animatedBg;
            },
            className: style['background'],
            style: {
              backgroundImage: "url(".concat(backgroundImage, ")")
            }
          }), /*#__PURE__*/_jsx("div", {
            className: style['image'],
            style: {
              backgroundImage: "url(".concat(textImage, ")")
            }
          }), footnote && /*#__PURE__*/_jsx("div", {
            className: style['footnote'],
            children: footnote
          })]
        })
      });
    }
  }, {
    key: "getParams",
    value: function getParams() {
      if (this.container) {
        this.topPosition = this.container.offsetTop - window.innerHeight;
        this.bottomPosition = this.topPosition + this.container.offsetHeight + window.innerHeight;
      }
    }
  }]);
  return ParallaxTemplate;
}(React.Component);